export default {
  // apiBaseUrl: 'http://192.168.1.6:3000/api/',
  apiBaseUrl: 'https://staging-clcgiving.xyz/api/',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  accessDeniedPath: '/access-denied',
  expires: 365,
  secure: true
};
